(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welaza-collections-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('welaza-catalog-controller')) {
    class WelazaCatalogController extends HTMLElement {}
    customElements.define('welaza-catalog-controller', WelazaCatalogController);
  }

  document.addEventListener('click', function (event) {
    const tab = event.target.closest('[data-catalog-tab]');
    if (!tab) return;

    const catalog = tab.closest('[data-welaza-catalog]');
    if (!catalog) return;

    const index = tab.dataset.catalogTab;
    catalog.querySelectorAll('[data-catalog-tab]').forEach(function (item) {
      const active = item.dataset.catalogTab === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });

    catalog.querySelectorAll('[data-catalog-panel]').forEach(function (panel) {
      const active = panel.dataset.catalogPanel === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    const search = catalog.closest('.welaza-catalog')?.querySelector('[data-catalog-search]');
    if (search && search.value) search.dispatchEvent(new Event('input', { bubbles: true }));
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-catalog-search]')) return;

    const section = event.target.closest('.welaza-catalog');
    if (!section) return;

    const term = event.target.value.trim().toLowerCase();
    const clear = section.querySelector('[data-catalog-clear]');
    const empty = section.querySelector('[data-catalog-empty]');
    const activePanel = section.querySelector('[data-catalog-panel].is-active');
    let visibleCards = 0;

    if (clear) clear.hidden = term.length === 0;

    section.querySelectorAll('.welaza-catalog-card').forEach(function (card) {
      if (!activePanel || !activePanel.contains(card)) {
        card.classList.remove('is-search-hidden');
        return;
      }
      const matches = !term || card.textContent.toLowerCase().includes(term);
      card.classList.toggle('is-search-hidden', !matches);
      if (matches) visibleCards += 1;
    });

    activePanel?.querySelectorAll('[data-catalog-group]').forEach(function (group) {
      const hasVisibleCard = Boolean(group.querySelector('.welaza-catalog-card:not(.is-search-hidden)'));
      group.classList.toggle('is-search-hidden', !hasVisibleCard);
    });

    if (empty) empty.hidden = visibleCards > 0;
  });

  document.addEventListener('click', function (event) {
    const clear = event.target.closest('[data-catalog-clear]');
    if (!clear) return;
    const section = clear.closest('.welaza-catalog');
    const input = section && section.querySelector('[data-catalog-search]');
    if (!input) return;
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welaza-partnership"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('.welaza-partnership__button--hero');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
